import { createContext, useContext, useMemo } from "react";
import { makeTFunc } from "../lib/i18n";
import { useAuth } from "./AuthContext";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const { user } = useAuth();
  const lang = user?.pais === "pt" ? "pt" : "es";
  const t = useMemo(() => makeTFunc(lang), [lang]);

  return (
    <LangContext.Provider value={{ lang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
